<template>
  <div class="header q-pb-md">
    <div class="text">
      {{ header }}
      <img
        src="/assets/icons/small-info.svg"
        :style="convertColourComputed ? convertColourComputed : ''"
        v-if="info && info != ''"
        :title="info"
        :alt="info"
        style="cursor: pointer"
        @click="openDialog"
      />
    </div>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
import { GlobalDialog } from '../../components/Dialogs/GlobalDialog';
import { mapState } from 'vuex';
import ColoureMixins from '../../mixins/ColourMixins.js';

export default {
  name: 'SubHeader',
  mixins: [ColoureMixins],
  props: {
    header: String,
    dialog: String,
    info: String
  },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard
    }),
    convertColourComputed() {
      return this.convertColour();
    },
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    }
  },
  methods: {
    openDialog: function () {
      if (!this.dialog) return;

      if (this.dialog === 'PersonalGuarantee') {
        this.$euiNotifications.emit({
          notification: GlobalDialog,
          /* body: '<span style="color:white">By providing a personal guarantee you will be responsible for paying any amount owing under the lease(s) in the event that the  lessee does not pay.</span>', */
          body: `<span style="color:white">(i) By providing a personal guarantee you will be responsible for paying any amount owing under the lease(s) in the event that the lessee does not pay.  You will be provided with an opportunity to review the terms of the personal guarantee before signing it.</span> <br/> <br/>
          <span style="color:white">Providing a personal guarantee enables this application to be assessed immediately. If the application meets our credit criteria, this will result in an approval for up to $300,000 which covers 3 to 4 average priced vehicles.</span>
          `,
          qCardStyle: {
            padding: '0',
            width: '400px',
            maxWidth: '80vw',
            backgroundColor: 'var(--primary-color)'
          },
          closeBtnStyle: {
            color: 'white'
          }
        });
      } else if (this.dialog === 'primaryApplicantInfo') {
        /*const textAU =
           '<span style="color:white"><b>Who is an Authorised Officer?</b><br/><br/>' +
           '<b>Sole Trader:</b> The owner of the entity is an authorised officer as listed on ASIC.<br/><br/>' +
           '<b>Company:</b> A director OR company secretary is an authorised officer as listed on ASIC.</span>';*/
        /* const textNZ =
          '<span style="color:white"><b>Who is an Authorised Officer?</b><br/><br/>' +
          '<b>Sole Trader:</b> The owner of the entity is an authorised officer.<br/><br/>' +
          '<b>Company:</b> A director is an  authorised officer as listed at NZ Companies Office.</span>';*/

        const textAU =
          '<span style="color:white"><b>Who is an Authorised Officer?</b><br/><br/>' +
          '<b>Sole Trader:</b> The owner of the business.<br/><br/>' +
          '<b>Company:</b> A director or company secretary.</span>';

        const textNZ =
          '<span style="color:white"><b>Who is an Authorised Officer?</b><br/><br/>' +
          '<b>Sole Trader:</b> The owner of the business. <br/><br/>' +
          '<b>Company:</b> A director or a person with delegated authority.</span>';

        this.$euiNotifications.emit({
          notification: GlobalDialog,
          body: this.region === 'NZ' ? textNZ : textAU,
          qCardStyle: {
            padding: '0',
            width: '400px',
            maxWidth: '80vw',
            backgroundColor: 'var(--primary-color)'
          },
          closeBtnStyle: {
            color: 'white'
          }
        });
      } else if (this.dialog === 'secondaryApplicantInfo') {
        this.$euiNotifications.emit({
          notification: GlobalDialog,
          body: '<span style="color:white">A Secondary Authorised Officer is required to countersign the vehicle lease agreement.</span>',
          qCardStyle: {
            padding: '0',
            width: '400px',
            maxWidth: '80vw',
            backgroundColor: 'var(--primary-color)'
          },
          closeBtnStyle: {
            color: 'white'
          }
        });
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.header
  position: relative;
  z-index: 1;
.text
  background: white;
  display: inline-block;
  padding-right: 10px;
  color: $primary;
  font-weight: 500;
.header:after
  content: '';
  display: block;
  border-bottom: 1px solid rgba(0,0,0,0.2);
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  z-index: -1;
img
  vertical-align: middle;
  margin: 0 0 3px 3px;
</style>
